<template lang="pug">
  include ../../../pug/mixins/bem
  a(href='',
    @click.prevent='openPopup()')
    slot(name='title')
      p {{ title }}
</template>

<script>
export default {
  name: 'ModalTrigger',
  props: {
    title: {}, 
    form: {type: String, default: () => null},
    classes: {},
    modalClasses: {}
  },
  methods: {
    openPopup() {
      this.$modal.show(this.componentLoader, 
      {
        classes: this.classes,
        showText: false
      }, {
        height: 'auto',
        name: this.form,
        minWidth: 300,
        maxWidth: 370,
        adaptive: true,
        classes: this.modalClasses,
        scrollable: true
      })
    },
  },
  computed: {
    componentLoader () { 
      return () => import(`../components/${this.form}.vue`)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/js/shared/components/ModalTrigger.vue